// istanbul ignore file
import { Button } from '@interstate/components/Button';
import { EllipsisHorizontalIcon } from '@interstate/components/Icons';
import { Menu, useMenu } from '@interstate/components/Menu';
import type { ProposalMetadata } from '@makemydeal/dr-dash-types';

const Actions: React.FC<{
    record: ProposalMetadata;
    setProposalToRemove: (id: string) => void;
    onCopyProposal: (id: string) => void;
    onSetPrimaryProposal: (id: string) => void;
    isBalloonOrFlexBuy?: boolean;
}> = ({ record, setProposalToRemove, onCopyProposal, onSetPrimaryProposal, isBalloonOrFlexBuy = false }) => {
    const menuReferenceProps = useMenu();
    const isFourSquare = record.type === 'fourSquare';
    const isFourSquareActionsDisabled = isFourSquare && isBalloonOrFlexBuy;

    const onCopy = (id: string) => {
        menuReferenceProps.setOpen(false);
        onCopyProposal(id);
    };

    const onDelete = (id: string) => {
        menuReferenceProps.setOpen(false);
        setProposalToRemove(id);
    };

    const onSetPrimary = (id: string) => {
        menuReferenceProps.setOpen(false);
        onSetPrimaryProposal(id);
    };

    const menuOptions = [
        ...(!isFourSquare
            ? [
                  {
                      value: 'string',
                      label: 'Set Primary',
                      onSelect: () => onSetPrimary(record.id),
                      disabled: record.isPrimary
                  }
              ]
            : []),
        {
            value: 'string',
            label: 'Copy Proposal',
            onSelect: () => onCopy(record.id),
            divider: true,
            disabled: isFourSquareActionsDisabled
        },
        {
            value: 'string',
            label: 'Remove Proposal',
            onSelect: () => onDelete(record.id),
            disabled: record.isDefault || isFourSquareActionsDisabled
        }
    ];

    return (
        <>
            <Button
                data-testid="actions-button"
                buttonStyle="tertiary"
                icon={<EllipsisHorizontalIcon />}
                onClick={menuReferenceProps.onClick}
                ref={menuReferenceProps.setAnchorEl}
            />
            <Menu
                id={'proposal-action-selector'}
                position={'bottom-start'}
                menuOptions={menuOptions}
                referenceProps={menuReferenceProps.referenceProps}
            />
        </>
    );
};

export default Actions;
